import { generateHTML } from '@tiptap/html';
import { legalEditorExtensions } from './legalEditorExtensions';

/**
 * Renders stored TipTap JSON (`content`) to HTML without a live editor, using the
 * same extension set as the legal editor. Readers (the Tock consumer today, and
 * jce-web once wired) render straight from this JSON, so the admin review/preview
 * stays in lockstep with what actually ships.
 *
 * Returns `null` when `content` is empty or is not valid TipTap JSON, so callers
 * can render an empty string instead.
 */
export const renderLegalContentHtml = (content?: string | null): string | null => {
  if (!content) {
    return null;
  }
  try {
    return generateHTML(JSON.parse(content), legalEditorExtensions());
  } catch {
    return null;
  }
};
